var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.375C4.02344 11.375 2.21875 10.3438 1.23047 8.625C0.242188 6.92773 0.242188 4.84375 1.23047 3.125C2.21875 1.42773 4.02344 0.375 6 0.375C7.95508 0.375 9.75977 1.42773 10.748 3.125C11.7363 4.84375 11.7363 6.92773 10.748 8.625C9.75977 10.3438 7.95508 11.375 6 11.375ZM5.14062 7.59375C4.83984 7.59375 4.625 7.83008 4.625 8.10938C4.625 8.41016 4.83984 8.625 5.14062 8.625H6.85938C7.13867 8.625 7.375 8.41016 7.375 8.10938C7.375 7.83008 7.13867 7.59375 6.85938 7.59375H6.6875V5.70312C6.6875 5.42383 6.45117 5.1875 6.17188 5.1875H5.14062C4.83984 5.1875 4.625 5.42383 4.625 5.70312C4.625 6.00391 4.83984 6.21875 5.14062 6.21875H5.65625V7.59375H5.14062ZM6 3.125C5.61328 3.125 5.3125 3.44727 5.3125 3.8125C5.3125 4.19922 5.61328 4.5 6 4.5C6.36523 4.5 6.6875 4.19922 6.6875 3.8125C6.6875 3.44727 6.36523 3.125 6 3.125Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.5ecc010a89d76e99f7378079effdc5bd.svg";
export { ForwardRef as ReactComponent };